import { useMutation, useQueryClient } from "@tanstack/react-query";

import { api } from "@utils/api";

import { immunizationQKeys } from "@hooks/queries/immunization/queryKeys";
import { timelineQKeys } from "@hooks/queries/timeline/queryKeys";


interface MutationProps {
  immunizationId: string;
  patientId: string;
}

export const useDeleteImmunization = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ immunizationId }: MutationProps) => {
      return api.delete(`preventative/${immunizationId}`);
    },
    onSuccess: (_, variables) => {
      // queryClient.invalidateQueries({
      //   queryKey: immunizationQKeys.patient(patientID),
      // });
      queryClient.invalidateQueries({
        queryKey: immunizationQKeys.patient(variables.patientId),
      });
      queryClient.invalidateQueries({
        queryKey: timelineQKeys.patient(variables.patientId),
      });
    },

    onError: res => {
      console.error("[From Delete Immunization]", res);
    },
  });
};
